import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * Hook that redirects signed-in users to dashboard when app is opened as PWA
 */
export function usePWARedirect() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only run once auth is loaded
    if (loading) return;

    // Check if running as installed PWA (standalone mode)
    const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
    const isInWebAppiOS = (window.navigator as unknown as { standalone?: boolean }).standalone === true;
    const isPWA = isStandalone || isInWebAppiOS;

    // If PWA, user is signed in, and on landing page, redirect to dashboard
    if (isPWA && user && location.pathname === "/") {
      navigate("/dashboard", { replace: true });
    }
  }, [user, loading, location.pathname, navigate]);
}
